import { Injectable } from '@angular/core';
import { registerSparkComponents } from 'genesys-spark';

@Injectable({
  providedIn: 'root'
})
export class GenesysSparkWrapperService {

  constructor() {  }
  register(): Promise<any> {    return registerSparkComponents();    }  
}
